import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Scenario } from '@shared/interfaces/scenario';
import { ChileanPesoPipe } from '@shared/pipes/chilean-peso.pipe';
import { CustomPercentPipe } from '@shared/pipes/custom-percent.pipe';

@Component({
  selector: 'app-fec-summary-income',
  standalone: true,
  imports: [
    CommonModule,
    ChileanPesoPipe,
    CustomPercentPipe
  ],
  templateUrl: './fec-summary-income.component.html',
  styleUrl: './fec-summary-income.component.scss'
})
export class FecSummaryIncomeComponent {
  @Input() scenario?: Scenario;
}
